import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";
import api from "../lib/api";
import { fmtTerm } from "./OfferCard";

import { tr, localeTag } from "../i18n";
export default function TopRates() {
  const [top, setTop] = useState([]);

  useEffect(() => {
    api.get("/uk-offers").then((r) =>
      setTop(r.data.filter((o) => o.status === "verified").sort((a, b) => b.rate_aer - a.rate_aer).slice(0, 3))
    ).catch(() => setTop([]));
  }, []);

  if (!top.length) return null;
  const checked = new Date(top[0].last_checked).toLocaleDateString(localeTag(), { day: "numeric", month: "short", year: "numeric" });

  return (
    <section id="top-rates" data-testid="top-rates-section" className="bg-[#0b1f3a] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <span className="inline-flex items-center gap-2 text-[12px] uppercase tracking-widest text-[#c2a15a] font-medium">
              <Trophy size={15} /> {tr("Top UK fixed rates")}
            </span>
            <h2 className="font-display text-[30px] md:text-[40px] text-white leading-tight mt-3">{tr("The three highest verified rates")}</h2>
            <p className="text-white/55 text-[14px] mt-2">{tr("Checked against current provider and market data on")} {checked}.</p>
          </div>
          <Link to="/uk-fixed-deposits" data-testid="top-rates-view-all"
            className="inline-flex items-center gap-2 self-start md:self-auto rounded-full bg-[#c2a15a] hover:bg-[#d8bd82] text-[#0b1f3a] text-[13px] font-semibold uppercase tracking-wide px-6 py-3 transition-colors">
            {tr("View all offers")} <ArrowRight size={16} />
          </Link>
        </div>
        <ol className="grid md:grid-cols-3 gap-5">
          {top.map((o, i) => (
            <li key={o.id} data-testid={`top-rate-${i + 1}`} style={{ animationDelay: `${i * 120}ms` }}
              className="top-rate-in rounded-2xl bg-white/5 ring-1 ring-white/10 p-6 hover:bg-white/10 transition-colors">
              <div className="flex items-center justify-between">
                <span className="font-display text-[#c2a15a] text-[15px]">{tr("No.")} {i + 1}</span>
                <span className="rounded-full ring-1 ring-[#c2a15a]/40 text-[#c2a15a] text-[12px] px-3 py-1">{fmtTerm(o.term_months)}</span>
              </div>
              <p className="font-display text-[44px] text-white leading-none mt-6">
                {o.rate_aer.toFixed(2)}<span className="text-[22px]">%</span>
                <span className="font-sans text-[13px] text-white/50 ml-2">{tr("p.a. AER")}</span>
              </p>
              <p className="text-white text-[17px] mt-5">{o.bank}</p>
              <p className="text-white/50 text-[13px] mt-1">{tr(o.product_name)} {tr("· from £")}{o.min_deposit.toLocaleString("en-GB")}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
